import axios from "./axios";

class PurchaseRepository {
  create(data) {
    return axios.post(`/orders`, data);
  }
  capture(data) {
    return axios.get(`/orders/${data.orderID}/capture`);
  }
}

export default new PurchaseRepository();



// WEBPACK FOOTER //
// ./src/data/purchase.repository.js